import { render, staticRenderFns } from "./ProjectItemNumberDialog.vue?vue&type=template&id=f1f24b3a&scoped=true&"
import script from "./ProjectItemNumberDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectItemNumberDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectItemNumberDialog.vue?vue&type=style&index=0&id=f1f24b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f24b3a",
  null
  
)

export default component.exports